var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2379_36402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 20.25C13.836 20.25 13.5 20.586 13.5 21V23.25C13.5 23.664 13.836 24 14.25 24C14.664 24 15 23.664 15 23.25V21C15 20.586 14.664 20.25 14.25 20.25ZM5.25 20.25C4.836 20.25 4.5 20.586 4.5 21V23.25C4.5 23.664 4.836 24 5.25 24C5.664 24 6 23.664 6 23.25V21C6 20.586 5.664 20.25 5.25 20.25ZM9.75 20.25C9.336 20.25 9 20.586 9 21V23.25C9 23.664 9.336 24 9.75 24C10.164 24 10.5 23.664 10.5 23.25V21C10.5 20.586 10.164 20.25 9.75 20.25ZM18.75 20.25C18.336 20.25 18 20.586 18 21V23.25C18 23.664 18.336 24 18.75 24C19.164 24 19.5 23.664 19.5 23.25V21C19.5 20.586 19.164 20.25 18.75 20.25ZM17.3002 3.77176C16.1993 1.53902 13.9073 0 11.25 0C7.68824 0 4.77749 2.76075 4.52474 6.25875C1.90651 7.00498 0 9.29251 0 12C0 15.1942 2.65502 17.7982 6 17.982C6 17.982 16.3733 18 16.5 18C20.4353 18 24 14.8102 24 10.875C24 7.08377 21.036 3.99298 17.3002 3.77176ZM16.5 16.5C16.4047 16.5 6 16.5 6 16.5C6 16.5 1.47149 16.035 1.5 12C1.51576 9.72302 3.60898 7.68749 6 7.5C6 4.39349 7.98824 1.5 11.25 1.5C13.8247 1.5 15.5422 3.07125 16.1535 5.25976C19.8698 5.09776 22.383 8.03777 22.5 10.5C22.6575 13.8097 19.2007 16.5 16.5 16.5Z",
    fill: "#DADADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2379_36402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDull);
export default __webpack_public_path__ + "static/media/dull.bb7a189f0a07f7c78e7da98fd6b70976.svg";
export { ForwardRef as ReactComponent };